import React from 'react';
import { LuPlus, LuCheck } from 'react-icons/lu';
import { COPY } from '../../contracts/copyMap';
import ButtonSpinner from '../oracle/ButtonSpinner';
import ButtonShimmer from '../oracle/ButtonShimmer';

// PUBLISH GLOWUP button states:
//   disabled    #242423 bg / #6e6a62 text until both slots are filled
//   ready       metallic gradient, ink text
//   submitting  metallic chrome + shimmer sweep + ring spinner, "SUBMITTING"
//   published   metallic, "GLOWUP PUBLISHED" + check (pre-navigation beat)
//
// Submitting deliberately keeps the LIVE metallic fill rather than dropping to
// the dead #242423 it used to share with the disabled state. Publishing a
// glowup uploads two photos and can run the whole Oracle pipeline on each, so
// this is the longest wait on the surface — greying out mid-press reads as the
// button having rejected the tap.
const PublishButton = ({ state = 'disabled', onClick, className = '' }) => {
  const ready = state === 'ready';
  const published = state === 'published';
  const submitting = state === 'submitting';
  const label =
    published ? 'GLOWUP PUBLISHED' : submitting ? COPY.BUTTON_SUBMITTING : 'PUBLISH GLOWUP';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!ready}
      aria-busy={submitting || undefined}
      className={[
        'relative overflow-hidden w-full h-[52px] border-0 rounded-field flex items-center justify-center gap-2.5',
        'font-display uppercase text-[13px] lg:text-[13.5px] font-semibold tracking-[0.22em]',
        'transition-colors duration-200 ease-mogged',
        ready || published || submitting
          ? 'bg-metallic text-[#1A1A1A]'
          : 'bg-[#242423] text-[#6e6a62] cursor-default',
        ready ? 'cursor-pointer' : '',
        submitting ? 'cursor-wait' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {/* Metallic chrome while submitting — the band has to be the strong one. */}
      {submitting && <ButtonShimmer onLight />}
      <span className="relative z-10">{label}</span>
      {submitting && <ButtonSpinner className="relative z-10" />}
      {/* No icon while submitting — a plus sign next to SUBMITTING offers an
          action that is already in flight. */}
      {published && <LuCheck size={15} strokeWidth={1.8} aria-hidden="true" className="relative z-10" />}
      {!published && !submitting && <LuPlus size={15} strokeWidth={1.8} aria-hidden="true" className="relative z-10" />}
    </button>
  );
};

export default PublishButton;
